import { render } from "./executive-dash.vue?vue&type=template&id=06c5b2de&scoped=true"
import script from "./executive-dash.vue?vue&type=script&lang=js"
export * from "./executive-dash.vue?vue&type=script&lang=js"

import "./executive-dash.vue?vue&type=style&index=0&id=06c5b2de&lang=scss"
import "./executive-dash.vue?vue&type=style&index=1&id=06c5b2de&lang=scss&scoped=true"

import exportComponent from "/Users/jigarpyunt/Desktop/ArrowDT/Git/SDB/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c5b2de"]])

export default __exports__